<template>
  <div class="ProductItem">
    <div class="ProductItem--ImageContainer">
      <img
        v-if="product.featuredImage"
        :src="product.featuredImage.url"
        :alt="product.featuredImage.altText"
      />
    </div>
    <div class="ProductItem--Content">
      <div class="ProductItem--Title">{{ product.title }}</div>
      <div class="ProductItem--Description" v-if="product.productType">{{ product.productType }}</div>
      <div class="ProductItem--Footer" :class="{'mt-3': !showPrice}">
        <div>
          <div>{{ product.selectedOrFirstAvailableVariant.title }}</div>
          <div v-if="showPrice">{{ product.selectedOrFirstAvailableVariant.price.amount }} {{ currency }}</div>
        </div>
        <div class="ProductItem--Actions">
          <div class="InfoIcon" v-html="icons.info" @click="$emit('onProductDetail', product)"></div>
          <div class="AddIcon" v-html="icons.add" @click="$emit('onProductAdd', product)"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      icons: {},
      currency: {},
      product: {},
      showPrice: {
        type: Boolean,
        default: false
      }
    },
    data: function(){
      return {}
    },
    created() {
    },
    mounted(){
    },
    methods: {
    }
  }
</script>